import React, { Component } from "react";
import Button from "./Button";
import "./ButtonGroup.css";

const Configuration = require("./shared/configuration");

class ButtonGroup extends Component {
  constructor(props) {
    super(props);
    this.renderButtons = this.renderButtons.bind(this);
    this.getPath = this.getPath.bind(this);
  }

  getPath(param, value) {
    return Configuration.configurationToUrl(
      Configuration.configurationWithChanges(this.props.conf, [
        { [param]: value },
        { sign: { text: this.props.stashedText } }
      ])
    );
  }

  renderButtons() {
    return this.props.options.map((option, index) => (
      <Button
        path={this.getPath(this.props.name, option.value)}
        key={index}
        title={option.title}
        active={Configuration.configurationIncludes(
          this.props.conf,
          option.value
        )}
      />
    ));
  }

  render() {
    if (this.props.options.length > 1) {
      return (
        <div>
          <h3>{this.props.title}</h3>
          <div className="ButtonGroup">{this.renderButtons()}</div>
        </div>
      );
    } else {
      return null;
    }
  }
}
export default ButtonGroup;



// WEBPACK FOOTER //
// ./src/ButtonGroup.js